import React from 'react';
import PropTypes from 'prop-types';

import RedesignLoginForm from './RedesignLoginForm';

export default function RedesignLoginFormContainer({
  style = {},
  isReset,
  onSubmit,
  onResetButtonClicked,
  image,
  hideForgotPassword = false,
  error,
}) {
  return (
    <div className="login-container-redesign" style={style}>
      {image}
      <div style={{ width: '55%', marginLeft: 'auto', marginRight: 'auto' }}>
        <RedesignLoginForm
          isReset={isReset}
          handleSubmit={onSubmit}
          hideForgotPassword={hideForgotPassword}
          onResetButtonClicked={onResetButtonClicked}
          error={error}
        />
      </div>
    </div>
  );
}

RedesignLoginFormContainer.propTypes = {
  style: PropTypes.shape({}),
  isReset: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onResetButtonClicked: PropTypes.func.isRequired,
  image: PropTypes.node,
  hideForgotPassword: PropTypes.bool,
  error: PropTypes.string,
};

RedesignLoginFormContainer.defaultProps = {
  style: {},
  isReset: false,
  image: null,
  hideForgotPassword: false,
  error: null,
};
